import type { RouteRecordRaw } from "vue-router";

export const joinRoutes: RouteRecordRaw[] = [
  {
    path: "/join",
    component: () => import("../JoinLayout.vue"),
    children: [
      {
        path: "",
        name: "join",
        component: { render: () => null },
        meta: {
          requiresTeacher: true,
        },
      },
      {
        path: ":token",
        name: "join_with_token",
        component: () => import("./JoinTokenPage.vue"),
        meta: {
          requiresTeacher: true,
        },
      },
    ],
  },
];
